import {
  FcAssistant,
  FcInTransit,
  FcBullish,
  FcSalesPerformance,
  FcCancel,
  FcConferenceCall,
  FcCalendar,
} from "react-icons/fc";

function ProfileIcon({ permission }: any) {
  const iconSize = 28;

  switch (permission) {
    case "admin":
      return <FcAssistant size={iconSize} />;
    case "mktg":
      return <FcBullish size={iconSize} />;
    case "supplier":
      return <FcInTransit size={iconSize} />;
    case "sales":
      return <FcSalesPerformance size={iconSize} />;
    case "planning":
      return <FcCalendar size={iconSize} />;
    case "neo":
      return <FcConferenceCall size={iconSize} />;
    default:
      return <FcCancel size={iconSize} />;
  }
}
export default ProfileIcon;
